import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class ConversionRatetPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="well">
          <code>
            TODO: Conversion Rate Leaderboard
          </code>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

ConversionRatetPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

ConversionRatetPage.defaultProps = {
};

ConversionRatetPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(ConversionRatetPage);
